import Dexie from 'dexie';

export const offlineDb = new Dexie('offline-db');

offlineDb.version(1).stores({
  submissions: 'id, endpoint, created_at, retry_count, synced, status, last_attempt_at, submission_id',
});
